<template>
  <div style = "">
    <component :isModal="isModal"  v-for = '(listItem,index) of listItems' :key="index"  :is = 'itemComponent'  :item = 'listItem'  @item-clicked = 'onItemClicked'/>
    <slot>
    </slot>
  </div>
</template>

<script>
import CardListController from './controller';
export default new CardListController;
</script>



// WEBPACK FOOTER //
// component.vue?9ca73a8c